<div class="scheduleTable">
    <table>
        <thead>
            <tr class="row-cols-auto">
                <th>
                    <label class="container checkbox d-flex justify-content-center">
                        <input type="checkbox" [checked]="allSelected" (change)="selectAllRows()">
                        <span class="checkmark"></span>
                    </label>
                </th>
                <th *ngFor="let th of headers; let i = index" class="th-sort" (click)="sort(th, i)">{{th.title}}
                    <span class="sort">
                        <div class="sort-arrow sort-up"
                            [ngClass]="th.sorted == 0 && activeSortIndex === i? 'selected':'not-selected'"></div>
                        <div class="sort-arrow sort-down"
                            [ngClass]="th.sorted == 1 && activeSortIndex === i? 'selected':'not-selected'"></div>
                    </span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of calendarSvc.studentsListFiltered" [ngClass]="{ 'row-selected': item._checked == true,'hasSchedule': setHasScheduleClass(item)}">
                <td class="first-td">
                    <label class="container checkbox d-flex justify-content-center">
                        <input type="checkbox" [(ngModel)]="item._checked" (change)="onSelectRow(item)">
                        <span class="checkmark"></span>
                    </label>
                </td>
                <td>{{item.Class.viewValue}} </td>
                <td>{{item.ClassCode?.viewValue}} </td>
                <td>{{item.Classification?.viewValue}}</td>
                <td>{{item.City}} </td>
                <td>{{item.IdentityNumber}}</td>
                <td class="last-td">{{item.Name}}</td>
            </tr>
        </tbody>
    </table>
</div>